import { Select } from "antd";
import { useTagsStore } from "modules/configure_tags/store";
import React, { useEffect } from "react";

function TagFilter({ selectedTag, setSelectedTag, tag }) {
  const { tagsData, fetchAllTagData } = useTagsStore();

  useEffect(() => {
    fetchAllTagData();
  }, []);

  return (
    <div>
      <Select
        placeholder="Select roles"
        defaultValue="Oral Minoxidil"
        onChange={(data)=>setSelectedTag(data)}
        style={{ width: "170px" }}
        optionFilterProp="label"
        value={selectedTag||tag}
        maxTagCount={1}
        allowClear
        showSearch
      >
        {tagsData?.map((role) => (
          <Option key={role?.display_name} label={role?.display_name} value={role?.display_name}>
            {role?.display_name}
          </Option>
        ))}
      </Select>
    </div>
  );
}

export default TagFilter;
